//
import Model from '@/models/Model'

/**
 * This class describes a hr employee loan company.
 *
 * @class      HrEmployeeLoanCompany (name)
 */
export default class HrEmployeeLoanCompany extends Model {

	/**
	 * @description
	 * Employee Loan Company includes
	 * 
	 * @type       {array}
	 */
	static includes = [
		'hr_employee',
	]

	/**
	 * { property_description }
	 *
	 * @type       {<type>}
	 */
	get hr_employee_full_name() {
		return this.hr_employee ? `${this.hr_employee.names} ${this.hr_employee.last_name1} ${this.hr_employee.last_name2}` : '-'
	}

	get period_month_init_suffixed() {
		return this.period_month_init < 10 ? `0${this.period_month_init}` : this.period_month_init
	}

	/**
	 * @description
	 * Period string getter
	 *
	 * @type       {string}
	 */
	get period_str() {
		return `${this.period_year_init}-${this.period_month_init_suffixed}`
	}

	reset() {

		//
		this.period = `${this.period_year_init}-${this.period_month_init_suffixed}`

		//
		return this
	}

	/**
	 * Endpoint name
	 *
	 * @return     {string}  api enpoint name
	 */
    resource() {
        return 'hr_employee_loan_company'
    }

    /**
     * Returns a create representation of the object.
     *
     * @return     {HrEmployeeLoanCcaf}  Create representation of the object.
     */
    toCreate() {

    	//
    	this.period_month_init = Number(this.period.split('-').pop())
    	this.period_year_init = Number(this.period.split('-').shift())

    	//
    	return this.clean([
    		'hr_employee_id',
		    'period_year_init',
		    'period_month_init',
		    'quote_amount',
		    'quote_total',
    	])
    }

    /**
     * Returns a create representation of the object.
     *
     * @return     {HrEmployeeLoanCcaf}  Create representation of the object.
     */
    toUpdate() {

    	//
    	this.period_month_init = Number(this.period.split('-').pop())
    	this.period_year_init = Number(this.period.split('-').shift())

    	//
    	return this.clean([
    		'hr_employee_id',
    		'id',
		    'period_year_init',
		    'period_month_init',
		    'quote_amount',
		    'quote_total',
    	])
    }
}
